<ng-container *ngIf="action$ | async as action">
    <p-button icon="pi pi-hidden" [label]="action.description" ntapDebounceClick (onClick)="executeAction($event)"
        [disabled]="action.disabled"></p-button>
</ng-container>